import { StatementRowType } from "./";

export function statementRowIsGroup(statementRow: StatementRow): boolean {
    return StatementRowType.GROUP === statementRow.type;
}

export function statementRowIsCategory(statementRow: StatementRow): boolean {
    return StatementRowType.CATEGORY === statementRow.type;
}
